<script setup>
import { Link } from '@inertiajs/vue3'
import { ChevronLeft } from 'lucide-vue-next'

defineProps({
  title: { type: String, required: true },
  aircraft: { type: Object, required: true },
  backLabel: { type: String, default: 'Visão Geral' },
  backHref: { type: String, default: '/' },
})
</script>

<template>
  <header class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
    <div>
      <Link
        :href="backHref"
        class="inline-flex items-center gap-1 text-sm text-slate-500 transition-colors hover:text-up-orange"
      >
        <ChevronLeft class="h-4 w-4" aria-hidden="true" />
        {{ backLabel }}
      </Link>
      <h1 class="mt-2 text-2xl font-bold tracking-wide text-up-navy sm:text-3xl">{{ title }}</h1>
    </div>

    <p class="shrink-0 text-sm text-slate-500">
      <span class="font-semibold text-up-navy">{{ aircraft.registration }}</span>
      <span class="mx-1.5 text-slate-300">•</span>{{ aircraft.model }}
    </p>
  </header>
</template>
